import React from "react";
import { Typography } from "antd";
import { PlayCircleOutlined, SmileOutlined, UsergroupAddOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import GamePage from "./GamePage";

const Laughfools: React.FC = () => {
    const { t } = useTranslation();
    const restrictions = t("games.details.laughfools.restrictions", { returnObjects: true }) as string[];

    return (
        <GamePage
            game="laughfools"
            tagColor="gold"
            instructionIcons={[
                <UsergroupAddOutlined key="group" />,
                <SmileOutlined key="smile" />,
                <PlayCircleOutlined key="play" />,
            ]}
        >
            <section className="laughfools__variants" aria-labelledby="laughfools-variants-title">
                <Typography.Title level={2} id="laughfools-variants-title">
                    {t("games.details.laughfools.restrictionsTitle")}
                </Typography.Title>
                <ul>
                    {restrictions.map((restriction) => <li key={restriction}>{restriction}</li>)}
                </ul>
                <Typography.Paragraph>{t("games.details.laughfools.footer")}</Typography.Paragraph>
            </section>
        </GamePage>
    );
};

export default Laughfools;
